module.exports = __webpack_public_path__ + "static/media/YF82_6.3827de90.jpg";